import React, { Suspense, lazy } from 'react';

const PressDetailPageWrapper = lazy(() => import('./pressDetailPageWrapper'));

export const PressDetailPageWrapperLazy = () => {
    return (
        <Suspense fallback={<div>loading...</div>}>
            <PressDetailPageWrapper />
        </Suspense>
    );
};
